/**
 * Store приложения.
 *
 * Разделение обязанностей: серверное состояние — только в RTK Query,
 * локальное состояние интерфейса — в слайсах. Смешивать нельзя, иначе
 * появляются две версии правды об одной сущности.
 */

import { configureStore } from "@reduxjs/toolkit";

import { api, authReducer } from "@taskflow/client-core";

import { uiReducer } from "./uiSlice";

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    auth: authReducer,
    ui: uiReducer,
  },
  middleware: (getDefault) => getDefault().concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
